<div class="container-fluid pt-3">
	<jhi-collapsible heading="{{translateService.instant('attributes.passport.title')}}">
		<div class="container-fluid">
			<div class="row mb-3">
                <div class="col d-flex justify-content-end">
                    <button class="btn btn-outline-info" *jhiHasAnyAuthority="MODIFY_ATTRIBUTES_PERMISSIONS" (click)="createGermplasmAttribute(VariableTypeEnum.GERMPLASM_PASSPORT)"><i class="fa fa-asterisk fa-md" aria-hidden="true"></i> {{ 'new' | translate }}</button>
                </div>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-curved table-fixed" *ngIf="passportAttributes.length else nodata">
					<thead>
					<tr>
						<th scope="col" jhiTranslate="attributes.passport.variable">Variable</th>
						<th scope="col" jhiTranslate="attributes.passport.variable-description" style="width: 15%">Variable Desc</th>
						<th scope="col" jhiTranslate="attributes.passport.value">Value</th>
						<th scope="col" jhiTranslate="attributes.passport.date">Date</th>
						<th scope="col" jhiTranslate="attributes.passport.location" style="width: 20%">Location</th>
						<th scope="col" jhiTranslate="germplasm-details.actions" *jhiHasAnyAuthority="MODIFY_ATTRIBUTES_PERMISSIONS" class="fit">Actions</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let attribute of passportAttributes">
						<td>
							<a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
							   [queryParams]="{ variableId: attribute.variableId }">{{attribute.variableName}}</a>
						</td>
						<td>{{attribute.variableDescription}}</td>
						<td class="word-wrap" [class.accepted-value]="!isValidValue(attribute)"><truncate-span [textInput]="attribute.value" [maxLength]="MAX_ATTRIBUTE_DISPLAY_SIZE"></truncate-span></td>
						<td>{{attribute.date}}</td>
						<td>{{attribute.locationName}}</td>
						<td class="fit" *jhiHasAnyAuthority="ATTRIBUTES_ACTIONS_PERMISSIONS">
							<button class="btn btn-outline-info btn-sm me-2" (click)="editGermplasmAttribute(VariableTypeEnum.GERMPLASM_PASSPORT, attribute)" *jhiHasAnyAuthority="MODIFY_ATTRIBUTES_PERMISSIONS">
								<i class="fa fa-edit fa-md" aria-hidden="true"></i>
							</button>
							<button class="btn btn-outline-info btn-sm me-2" (click)="deleteGermplasmAttribute(attribute)" *jhiHasAnyAuthority="MODIFY_ATTRIBUTES_PERMISSIONS">
								<i class="fa fa-trash fa-md" aria-hidden="true"></i>
							</button>
							<button class="btn btn-outline-info btn-sm me-2" (click)="openGermplasmAttributeAuditChanges(VariableTypeEnum.GERMPLASM_PASSPORT, attribute)" *jhiHasAnyAuthority="GERMPLASM_AUDIT_PERMISSION">
								<i class="fa fa-list fa-md" aria-hidden="true"></i>
							</button>
							<button class="btn btn-outline-info btn-sm me-2" (click)="gotoFiles(attribute)" *ngIf="attribute.hasFiles && isFileStorageConfigured">
								<i class="fa fa-file fa-md" aria-hidden="true"></i>
							</button>
						</td>

					</tr>
					</tbody>
				</table>
				<ng-template #nodata>
					<table class="table table-striped table-bordered table-curved">
						<thead>
						<tr>
							<th></th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td jhiTranslate="no.data"></td>
						</tr>
						</tbody>
					</table>
				</ng-template>
			</div>
		</div>
	</jhi-collapsible>
	<jhi-collapsible heading="{{translateService.instant('attributes.attributes.title')}}">
		<div class="container-fluid">
            <div class="row mb-3">
                <div class="col d-flex justify-content-end">
                    <button class="btn btn-outline-info" *jhiHasAnyAuthority="MODIFY_ATTRIBUTES_PERMISSIONS" (click)="createGermplasmAttribute(VariableTypeEnum.GERMPLASM_ATTRIBUTE)"><i class="fa fa-asterisk fa-md" aria-hidden="true"></i> {{ 'new' | translate }}</button>
                </div>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-curved table-fixed" *ngIf="attributes.length else nodata">
					<thead>
					<tr>
						<th scope="col" jhiTranslate="attributes.attributes.variable">Variable</th>
						<th scope="col" jhiTranslate="attributes.attributes.variable-description" style="width: 15%">Description</th>
						<th scope="col" jhiTranslate="attributes.attributes.value">Value</th>
						<th scope="col" jhiTranslate="attributes.attributes.date">Date</th>
						<th scope="col" jhiTranslate="attributes.attributes.location" style="width: 20%">Location</th>
						<th scope="col" jhiTranslate="germplasm-details.actions" *jhiHasAnyAuthority="MODIFY_ATTRIBUTES_PERMISSIONS" class="fit">Actions</th>
					</tr>
					</thead>
					<tbody>
					<tr *ngFor="let attribute of attributes">
						<td>
							<a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
							   [queryParams]="{ variableId: attribute.variableId }">{{attribute.variableName}}</a>
						</td>
						<td>{{attribute.variableDescription}}</td>
						<td class="word-wrap" [class.accepted-value]="!isValidValue(attribute)">
							<truncate-span [textInput]="attribute.value" [maxLength]="MAX_ATTRIBUTE_DISPLAY_SIZE"></truncate-span>
						</td>
						<td>{{attribute.date}}</td>
						<td>{{attribute.locationName}}</td>
						<td class="fit" *jhiHasAnyAuthority="ATTRIBUTES_ACTIONS_PERMISSIONS">
							<button class="btn btn-outline-info btn-sm me-2" (click)="editGermplasmAttribute(VariableTypeEnum.GERMPLASM_ATTRIBUTE, attribute)" *jhiHasAnyAuthority="MODIFY_ATTRIBUTES_PERMISSIONS">
								<i class="fa fa-edit fa-md" aria-hidden="true"></i>
							</button>
							<button class="btn btn-outline-info btn-sm me-2" (click)="deleteGermplasmAttribute(attribute)" *jhiHasAnyAuthority="MODIFY_ATTRIBUTES_PERMISSIONS">
								<i class="fa fa-trash fa-md" aria-hidden="true"></i>
							</button>
							<button class="btn btn-outline-info btn-sm me-2" (click)="openGermplasmAttributeAuditChanges(VariableTypeEnum.GERMPLASM_ATTRIBUTE, attribute)" *jhiHasAnyAuthority="GERMPLASM_AUDIT_PERMISSION">
								<i class="fa fa-list fa-md" aria-hidden="true"></i>
							</button>
							<button class="btn btn-outline-info btn-sm me-2" (click)="gotoFiles(attribute)" *ngIf="attribute.hasFiles">
								<i class="fa fa-file fa-md" aria-hidden="true"></i>
							</button>
						</td>
					</tr>
					</tbody>
				</table>
				<ng-template #nodata>
					<table class="table table-striped table-bordered table-curved">
						<thead>
						<tr>
							<th></th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td jhiTranslate="no.data"></td>
						</tr>
						</tbody>
					</table>
				</ng-template>
			</div>
		</div>
	</jhi-collapsible>
</div>
